import { setInteractionMode, localize } from 'VeeValidate'

export default function setupValidation(language, validationMessages) {

    //set the default intractionmode (https://logaretm.github.io/vee-validate/guide/interaction-and-ux.html#eager)
    setInteractionMode('custom', ({errors}) => {
        if (errors.length) {
            return {
                on: ['input', 'change', 'blur']
            };
        }

        return {
            on: [] //do not trigger validation at all until it is triggered manually at least once
        };
    });

    //setup error messages
    var loc = {};
    loc[language] = {};
    loc[language]["messages"] = validationMessages;
    localize(loc);

    //now set the language
    localize(language);
}